var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key},[_c('b-input',{ref:"question",class:_vm.reactiveClass,attrs:{"size":"sm"},on:{"change":_vm.savePoint},model:{value:(_vm.form.question),callback:function ($$v) {_vm.$set(_vm.form, "question", $$v)},expression:"form.question"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }